import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { CreateEdgePoolRequest, ICreateEdgePoolParams } from '../requests/CreateEdgePoolRequest';
import { DeleteEdgePoolsRequest, IDeleteEdgePoolsParams } from '../requests/DeleteEdgePoolsRequest';
import { GetEdgePoolsRequest, IGetEdgePoolsParams } from '../requests/GetEdgePoolsRequest';
import { IUpdateEdgePoolParams, UpdateEdgePoolRequest } from '../requests/UpdateEdgePoolRequest';

export namespace EdgePool {

  export function createPool(params: ICreateEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateEdgePoolRequest({ ...params }));
  }

  export function getPools(params: IGetEdgePoolsParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetEdgePoolsRequest({ ...params }));
  }

  export function deletePools(params: IDeleteEdgePoolsParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteEdgePoolsRequest({ ...params }));
  }

  export function updatePool(params: IUpdateEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateEdgePoolRequest({ ...params }));
  }
}
